/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { POST_ACES_SECRET_QUESTION_PASSWORD_RESET } from './actionTypes';

/**
 * Updates the details in the 'UAUserAccount' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesSecretQuestionPasswordResetReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_SECRET_QUESTION_PASSWORD_RESET);

/**
 * Updates the indicator of creation of details in the 'UAUserAccount' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesSecretQuestionPasswordResetReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_SECRET_QUESTION_PASSWORD_RESET);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesSecretQuestionPasswordResetErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_SECRET_QUESTION_PASSWORD_RESET);

const reducers = combineReducers({
  postAcesSecretQuestionPasswordReset: postAcesSecretQuestionPasswordResetReducer,

  isFetchingPostAcesSecretQuestionPasswordReset:
    isFetchingPostAcesSecretQuestionPasswordResetReducer,
  postAcesSecretQuestionPasswordResetError: postAcesSecretQuestionPasswordResetErrorReducer,
});

export default { reducers };
